module.exports = __webpack_public_path__ + "static/media/marcas.7189be5c.png";